import modelExtend from 'dva-model-extend';

import * as apis from 'services/group';
import { getCostCompositions, setCostCompositions } from 'services/cost';
import { createBasicStaticModel } from './common';

const model = createBasicStaticModel({
  apis,
  namespace: 'group',
  singleAttr: 'group',
  listAttr: 'groups',
});

export default modelExtend(model, {
  namespace: 'group',

  effects: {
    * getCostCompositions({ payload, output }, { call }) {
      const data = yield call(getCostCompositions, payload);
      if (output) output.value = data;
      if (!data.success) throw data;
    },

    * setCostCompositions({ payload, output }, { call }) {
      const data = yield call(setCostCompositions, payload);
      if (output) output.value = data;
      if (!data.success) throw data;
    },

    * createItemGroup({ payload, output }, { call, put }) {
      const { compositions, ...rest } = payload;
      const data = yield call(apis.create, rest);
      if (output) output.value = data;
      if (!data.success) throw data;
      yield put({
        type: 'updateState',
        payload: {
          lastCreatedItem: data.group,
        },
      });
      yield put({ type: 'query' });

      if (compositions) {
        yield put({ type: 'setCostCompositions', payload: { output_group_id: data.group.id, compositions } });
      }
    },

    * updateItemGroup({ payload, output }, { call, put }) {
      const { compositions, ...rest } = payload;

      const data = yield call(apis.update, rest);
      if (output) output.value = data;
      if (!data.success) throw data;
      yield put({ type: 'query' });

      if (compositions) {
        yield put({ type: 'setCostCompositions', payload: { output_group_id: payload.id, compositions } });
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/group.js